import { Column, CreateDateColumn, Entity, UpdateDateColumn, PrimaryGeneratedColumn, VersionColumn } from "typeorm";

@Entity('notify_party')
export class NotifyParty {
    @PrimaryGeneratedColumn("increment", { name: 'notify_party_id' })
    notifyPartyId: number;

    @Column("varchar", {
        nullable: false,
        name: "notify_party_name"
    })
    notifyPartyName: string;
    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    updateAt: Date;

    @Column("varchar", {
        nullable: false,
        default: 1,
        name: "created_user"
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user"
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
    createdAt: Date;
}